import "./PjpSummaryCard.css";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../providers/TranslationProvider";
import DescriptionIcon from "@mui/icons-material/Description";
import EventNoteIcon from "@mui/icons-material/EventNote";
import { Box, Button, TextField } from "@mui/material";
import { SummaryData } from "./PjpSummaryCardTypes";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PjpDayCard from "./PjpDayCard";
import { useEffect, useState } from "react";

function PjpSummaryCard({
  summaryData,
  dayCardData,
  comment,
  onCommentChange,
  error,
  showMonth = true
}: {
  summaryData: SummaryData;
  dayCardData: any;
  comment: string;
  onCommentChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: boolean;
  showMonth?: boolean;
}) {

  const { translate } = usePortalTranslation();


  const [showDetails, setShowDetails] = useState<boolean>(false);

  useEffect(() => {
    setShowDetails(false);
  }, [summaryData]);

  return (
    <div>
      <div className="pjp-summary-parent">
        <div className="pjp-header">
          {showMonth && <div className="header-text">
            <DescriptionIcon sx={{ color: "#31c2b1" }} />
            <span>{summaryData.month}</span>
          </div>}

          <div className="header-text">
            <div className="green-dot"></div>
            <span>{summaryData.status}</span>
          </div>
        </div>

        <hr />

        <div className="summary-props">
          {summaryData.PjpPlanOptions?.map((pjpPlan : any , i : number) => (
            <div key={i} className="summary-prop">

              <div className="summary-prop-detail">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: pjpPlan.textColor,
                    color: "white",
                  }}
                >
                  <EventNoteIcon />
                </Box>
                {pjpPlan.label.toUpperCase()}
              </div>
              <p className="summary-prop-count">{pjpPlan.count || 0}</p>

            </div>
          ))}
        </div>

        <div className="manager-comment">
          <TextField
            id="outlined-multiline-static"
            label="Manager Comment"
            multiline
            rows={4}
            value={comment} 
            onChange={onCommentChange} 
            error={error}
            helperText={error ? "Manager Comment cannot be empty": ""}
          />
        </div>

        <div className="show-details">
          <Button
            onClick={() => setShowDetails((prevState) => !prevState)}
            variant="contained"
          >
            {showDetails ? (
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <span>{translate(TranslationEnum.pjp_approval, "Hide Details")}</span>

                <KeyboardArrowUpIcon />
              </div>
            ) : (
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <span>{translate(TranslationEnum.pjp_approval, "Show Details")}</span>

                <KeyboardArrowDownIcon />
              </div>
            )}
          </Button>
        </div>
      </div>

      {showDetails && (
        <div className="pjp-day-parent">
          <PjpDayCard dayCardData={dayCardData} />
        </div>
      )}
    </div>
  );
}

export default PjpSummaryCard;

